import React from "react";
import ToolTip from "../../../../parts/tooltip";

import Avatar from "../../../../parts/avatar";
import ProgramCard from "../../../../parts/cards/program-card";
import getAvatarUrl from "../../../../utils/get-avatar-url";

const ProgramCardCP = (props) => {
  const { program } = props;
  const isTemplate =
    program.cycleAuthorId === program.cycleOwnerId &&
    program.cycleType === "coach";
  if (isTemplate) return <ProgramCard {...props} isTemplate={isTemplate} />;
  return (
    <article className="Coaching-Program-Card alt-cycle">
      <div
        className="image"
        style={{
          backgroundImage: `url("${
            program.cycleImage ||
            getAvatarUrl({
              name: program.cycleOwnerName,
              avatar: program.cycleOwnerAvatar,
            })
          }")`,
        }}
      ></div>

      <header className="details">
        <div className="name">{program.name}</div>
      </header>
      <ul className="programs">
        <li>
          <div className="Coaching-Program-Item">
            <div className="name">{program.cycleName}</div>

            <ToolTip id="overview" body="Overview">
              <a
                href={`/athlete-portal/programs/program-overview/${program.cycleId}?referrer=program-builder&athlete=${program.cycleOwnerId}&program=${program.order}`}
                className="overview-button"
              >
                <img src="/img/icons/overview.svg" alt="" />
              </a>
            </ToolTip>

            <ToolTip id="send-cycle" body="Send Cycle">
              <a
                href={`/actions/refresh/?modal[type]=send&cycleId=${program.cycleId}`}
                className="copy-button"
              >
                <img src="/img/icons/copy.svg" alt="" />
              </a>
            </ToolTip>
          </div>
        </li>
      </ul>

      <div className="foot">
        <Avatar
          user={{
            name: program.cycleOwnerName,
            avatar: program.cycleOwnerAvatar,
          }}
          size={32}
        />
        <div className="name">{program.cycleOwnerName}</div>
      </div>

      <footer className="more">
        <div className="content">
          <a
            href={`/athlete-portal/programs/program-overview/${program.cycleId}?referrer=program-builder&athlete=${program.cycleOwnerId}&program=${program.order}`}
          >
            <i className="icon">
              <img src="/img/icons/overview_white.svg" alt="" />
            </i>
            Overview
          </a>
          <a
            href={`/actions/refresh/?modal[type]=send&cycleId=${program.cycleId}&programOrder=${program.order}`}
          >
            <i className="icon">
              <img src="/img/icons/copy_white.svg" alt="" />
            </i>
            Send Program
          </a>
        </div>
      </footer>
    </article>
  );
};

export default ProgramCardCP;
